import { FETCH_CAISSES_FAILURE, FETCH_CAISSES_REQUEST, FETCH_CAISSES_SUCCESS, FETCH_CAISSES_SUCCESS_2, FETCH_CAISSE_FAILURE, FETCH_CAISSE_REQUEST, FETCH_CAISSE_SUCCESS } from "../actions/actions";



// caisseReducer.js
const initialState = {
    caisses: [],
    caisses2: [],
    caisse: {},
    caisseSelect: {},
    loadingCaisse:false,
    loadingCaisseSelect:false,
    loadingCaisses:false,
    errorCaisses:null,
    errorCaisse:null
    // ... autres états spécifiques à caisseReducer
  };
  
  const caisseReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CAISSE_REQUEST:
        // Dispatch une action pour définir loading sur true dans le globalReducer
        return {
          ...state,
          loadingCaisse:true,
          errorCaisses:""
          // Autres manipulations d'état pour la demande de récupération des caisses
        };
        case FETCH_CAISSE_SUCCESS:
        return {
          ...state,
          loadingCaisse:false,
          errorCaisses:"",
          caisse:action.payload
        };
        case FETCH_CAISSE_FAILURE:
        return {
          ...state,
          loadingCaisse:false,
          errorCaisses:action.payload
        };


      case FETCH_CAISSES_REQUEST:
        return {
          ...state,
          loadingCaisses:true,
          errorCaisses:""
        };
       
      case FETCH_CAISSES_SUCCESS:
        return {
          ...state,
          caisses: action.payload,
          loadingCaisses:false,
          errorCaisses:""
          // Autres manipulations d'état pour le succès de la récupération des caisses
        };
        case FETCH_CAISSES_SUCCESS_2:
        return {
          ...state,
          caisses2: action.payload,
          loadingCaisses:false,
          errorCaisses:""
          // Autres manipulations d'état pour le succès de la récupération des caisses
        };
        
      case FETCH_CAISSES_FAILURE:
        // Dispatch une action pour définir loading sur false dans le globalReducer et enregistrer l'erreur
        return {
          ...state,
          loadingCaisses:false,
          errorCaisses:action.payload
          // Autres manipulations d'état pour l'échec de la récupération des caisses
        };
      // ... autres cas pour d'autres actions liées aux caisses

        
      default:
        return state;
    }
  };
  
  export default caisseReducer;

  

